/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    TopGuildLeaderLeaderboard,
    TopGuildLeaderLeaderboardFromJSON,
    TopGuildLeaderLeaderboardFromJSONTyped,
    TopGuildLeaderLeaderboardToJSON,
} from './';

/**
 * 
 * @export
 * @interface GetTopGuildLeadersLeaderboardResponse
 */
export interface GetTopGuildLeadersLeaderboardResponse {
    /**
     * 
     * @type {Array<TopGuildLeaderLeaderboard>}
     * @memberof GetTopGuildLeadersLeaderboardResponse
     */
    leaders: Array<TopGuildLeaderLeaderboard>;
}

export function GetTopGuildLeadersLeaderboardResponseFromJSON(json: any): GetTopGuildLeadersLeaderboardResponse {
    return GetTopGuildLeadersLeaderboardResponseFromJSONTyped(json, false);
}

export function GetTopGuildLeadersLeaderboardResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTopGuildLeadersLeaderboardResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'leaders': ((json['leaders'] as Array<any>).map(TopGuildLeaderLeaderboardFromJSON)),
    };
}

export function GetTopGuildLeadersLeaderboardResponseToJSON(value?: GetTopGuildLeadersLeaderboardResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'leaders': ((value.leaders as Array<any>).map(TopGuildLeaderLeaderboardToJSON)),
    };
}


